import { Page } from "@boundary/layouts/pageLayout";
import { Button } from "@boundary/components/button";
import { OnboardingElement } from "@boundary/widgets/onboarding";
import { OnboardingFlowData, OnboardingFlowSteps } from "@boundary/pages/4.onboarding/onboardingFlow";
import { Stepper } from "@boundary/components/stepper";
import styles from "./map.module.scss";

export const OnboardingMapStep: OnboardingElement<
  OnboardingFlowData,
  OnboardingFlowSteps
> = (props) => {
  return (
    <Page withFog>
      <Page.SafeArea />
      <Page.DisplayZone>
        <Page.DisplayZone.Body className={styles.body}>
          <Stepper count={3} current={1} />
          <h1>Как нами пользоваться?</h1>
          <p>Просто найди удобный аппарат на карте и выбери нужную тебе услугу!</p>
          <div className={styles.imageContainer}>
            <img
              src="/assets/onboarding/map-onboarding.png"
              className={styles.image}
              alt=""
            />
          </div>
        </Page.DisplayZone.Body>
        <Page.DisplayZone.Sticky className={styles.buttonPad}>
          <Button onClick={() => props.onComplete("order")}>Далее</Button>
        </Page.DisplayZone.Sticky>
      </Page.DisplayZone>
    </Page>
  );
};
